(function () {
  const header = document.querySelector('[data-aw-header]');
  if (!header) return;

  // ── Scroll state ────────────────────────────────────────────
  let lastScroll = window.scrollY;

  const hideOnScroll = header.hasAttribute('data-hide-on-scroll');

  function applyScrollState() {
    const current = window.scrollY;
    header.classList.toggle('aw-header--scrolled', current > 50);
    if (hideOnScroll) {
      if (current > lastScroll && current > 120) {
        header.classList.add('aw-header--hidden');
      } else {
        header.classList.remove('aw-header--hidden');
      }
    }
    lastScroll = current;
  }

  // Apply immediately on load (handles page refresh mid-scroll)
  applyScrollState();

  window.addEventListener('scroll', applyScrollState, { passive: true });

  // Search close button (inside panel) — aw-popover handles open/outside-click
  const searchClose = document.querySelector('[data-aw-search-close]');
  if (searchClose) {
    searchClose.addEventListener('click', () => {
      const trigger = document.querySelector('[data-aw-search-toggle]');
      const panel   = document.querySelector('[data-aw-search-panel]');
      if (trigger && panel) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('aw-popover--open');
        panel.classList.remove('aw-popover--open', 'aw-search-panel--open');
      }
    });
  }

  // ── Country selector ────────────────────────────────────────
  document.querySelectorAll('[data-aw-country-option]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var form = link.closest('form');
      var input = form && form.querySelector('input[name="country_code"]');
      if (input && form) {
        input.value = link.dataset.value;
        form.submit();
      }
    });
  });

  var countrySearch = document.querySelector('[data-aw-country-search]');
  if (countrySearch) {
    countrySearch.addEventListener('input', function () {
      var query = countrySearch.value.toLowerCase().trim();
      var items = countrySearch.closest('[data-aw-popover-content]').querySelectorAll('li[data-country-name]');
      items.forEach(function (li) {
        var nameMatch = li.dataset.countryName.includes(query);
        var codeMatch = li.dataset.countryCode.includes(query);
        li.hidden = query !== '' && !nameMatch && !codeMatch;
      });
    });
  }

  // ── Mega menu hover with close delay ────────────────────────
  header.querySelectorAll('.aw-header__nav-item--has-dropdown').forEach((item) => {
    let closeTimer;

    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      item.classList.add('aw-header__nav-item--open');
    });

    item.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        item.classList.remove('aw-header__nav-item--open');
      }, 150);
    });
  });
})();